import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-pwa-install-icons',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="install-icons-guide" [class.ios]="platform === 'ios'" 
         [class.android]="platform === 'android'"
         [class.desktop]="platform === 'desktop'">
      
      <!-- Guide iOS avec icônes -->
      <div *ngIf="platform === 'ios'" class="icon-steps">
        <div class="icon-step" [class.active]="step === 1">
          <div class="icon-circle">
            <mat-icon class="animated-icon">ios_share</mat-icon>
          </div>
          <span class="step-label">Partage</span>
        </div>
        
        <div class="arrow">→</div>
        
        <div class="icon-step" [class.active]="step === 2">
          <div class="icon-circle">
            <mat-icon class="animated-icon">add_to_home_screen</mat-icon>
          </div>
          <span class="step-label">Écran d'accueil</span>
        </div>
        
        <div class="arrow">→</div>
        
        <div class="icon-step" [class.active]="step === 3">
          <div class="icon-circle">
            <mat-icon class="animated-icon">add_circle</mat-icon>
          </div>
          <span class="step-label">Ajouter</span>
        </div>
        
        <div class="arrow">→</div>
        
        <div class="icon-step" [class.active]="step === 4">
          <div class="icon-circle success">
            <mat-icon class="animated-icon">check_circle</mat-icon>
          </div>
          <span class="step-label">Installé!</span>
        </div>
      </div>

      <!-- Guide Android avec icônes -->
      <div *ngIf="platform === 'android'" class="icon-steps">
        <div class="icon-step" [class.active]="step === 1">
          <div class="icon-circle">
            <mat-icon class="animated-icon">more_vert</mat-icon>
          </div>
          <span class="step-label">Menu</span>
        </div>
        
        <div class="arrow">→</div>
        
        <div class="icon-step" [class.active]="step === 2">
          <div class="icon-circle">
            <mat-icon class="animated-icon">install_mobile</mat-icon>
          </div>
          <span class="step-label">Installer</span>
        </div>
        
        <div class="arrow">→</div>
        
        <div class="icon-step" [class.active]="step === 3">
          <div class="icon-circle success">
            <mat-icon class="animated-icon">check_circle</mat-icon>
          </div>
          <span class="step-label">Installé!</span>
        </div>
      </div>

      <!-- Guide Desktop avec icônes -->
      <div *ngIf="platform === 'desktop'" class="icon-steps">
        <div class="icon-step" [class.active]="step === 1">
          <div class="icon-circle">
            <mat-icon class="animated-icon">install_desktop</mat-icon>
          </div>
          <span class="step-label">Icône d'installation</span>
        </div>
        
        <div class="arrow">→</div>
        
        <div class="icon-step" [class.active]="step === 2">
          <div class="icon-circle">
            <mat-icon class="animated-icon">get_app</mat-icon>
          </div>
          <span class="step-label">Installer</span>
        </div>
        
        <div class="arrow">→</div>
        
        <div class="icon-step" [class.active]="step === 3">
          <div class="icon-circle success">
            <mat-icon class="animated-icon">check_circle</mat-icon>
          </div>
          <span class="step-label">Installé!</span>
        </div>
      </div>

      <!-- Message descriptif animé -->
      <div class="description-text" *ngIf="platform !== 'unknown'">
        <p class="animated-text">{{ getCurrentStepDescription() }}</p>
      </div>
    </div>
  `,
  styles: [`
    .install-icons-guide {
      padding: 30px 20px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    }

    .icon-steps {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;
      flex-wrap: wrap;
    }

    .icon-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      opacity: 0.5;
      transition: all 0.5s ease;
      transform: scale(0.9);
    }

    .icon-step.active {
      opacity: 1;
      transform: scale(1.1);
    }

    .icon-circle {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      border: 3px solid rgba(255, 255, 255, 0.3);
      transition: all 0.5s ease;
    }

    .icon-step.active .icon-circle {
      background: white;
      border-color: white;
      animation: pulse 1.5s infinite;
    }

    .icon-circle.success {
      background: #4caf50 !important;
      border-color: #4caf50 !important;
    }

    .animated-icon {
      font-size: 30px;
      color: white;
      transition: all 0.5s ease;
    }

    .icon-step.active .animated-icon {
      color: #764ba2;
      animation: bounce 1s infinite;
    }

    .icon-circle.success .animated-icon {
      color: white !important;
    }

    .step-label {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      max-width: 80px;
      transition: all 0.5s ease;
    }

    .icon-step.active .step-label {
      color: white;
      font-weight: bold;
    }

    .arrow {
      font-size: 24px;
      color: rgba(255, 255, 255, 0.5);
      animation: slideArrow 2s infinite;
    }

    .description-text {
      margin-top: 25px;
      text-align: center;
      padding: 15px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 10px;
      backdrop-filter: blur(10px);
    }

    .animated-text {
      color: white;
      font-size: 14px;
      margin: 0;
      animation: fadeInUp 0.5s ease;
      line-height: 1.6;
    }

    /* Animations */
    @keyframes pulse {
      0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
      }
      70% {
        box-shadow: 0 0 0 15px rgba(255, 255, 255, 0);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
      }
    }

    @keyframes bounce {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
    }

    @keyframes slideArrow {
      0%, 100% {
        transform: translateX(0);
      }
      50% {
        transform: translateX(5px);
      }
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    /* Responsive */
    @media (max-width: 600px) {
      .icon-steps {
        gap: 10px;
      }

      .icon-circle {
        width: 50px;
        height: 50px;
      }

      .animated-icon {
        font-size: 24px;
      }

      .arrow {
        font-size: 18px;
      }

      .step-label {
        font-size: 11px;
      }
    }

    /* Styles spécifiques par plateforme */
    .ios .icon-circle {
      background: rgba(0, 122, 255, 0.2);
      border-color: rgba(0, 122, 255, 0.5);
    }

    .ios .icon-step.active .icon-circle {
      background: #007AFF;
      border-color: #007AFF;
    }

    .ios .icon-step.active .animated-icon {
      color: white;
    }

    .android .icon-circle {
      background: rgba(66, 133, 244, 0.2);
      border-color: rgba(66, 133, 244, 0.5);
    }

    .android .icon-step.active .icon-circle {
      background: #4285f4;
      border-color: #4285f4;
    }

    .android .icon-step.active .animated-icon {
      color: white;
    }

    .desktop .icon-circle {
      background: rgba(52, 168, 83, 0.2);
      border-color: rgba(52, 168, 83, 0.5);
    }

    .desktop .icon-step.active .icon-circle {
      background: #34a853;
      border-color: #34a853;
    }

    .desktop .icon-step.active .animated-icon {
      color: white;
    }
  `]
})
export class PwaInstallIconsComponent {
  @Input() platform: 'ios' | 'android' | 'desktop' | 'unknown' = 'unknown';
  @Input() step: number = 1;

  private stepDescriptions = {
    ios: [
      'Appuyez sur le bouton de partage en bas de Safari',
      'Faites défiler et sélectionnez "Sur l\'écran d\'accueil"',
      'Appuyez sur "Ajouter" en haut à droite',
      'L\'application est maintenant installée sur votre écran d\'accueil!'
    ],
    android: [
      'Appuyez sur le menu (3 points) en haut à droite',
      'Sélectionnez "Installer l\'application"',
      'L\'application est maintenant installée!'
    ],
    desktop: [
      'Cliquez sur l\'icône d\'installation dans la barre d\'adresse',
      'Cliquez sur "Installer" dans la fenêtre qui apparaît',
      'L\'application est maintenant installée!'
    ]
  };

  constructor() {
    // Animation automatique des étapes
    this.animateSteps();
  }

  private animateSteps() {
    setInterval(() => {
      const maxSteps = this.platform === 'ios' ? 4 : 3;
      this.step = (this.step % maxSteps) + 1;
    }, 2500);
  }

  getCurrentStepDescription(): string {
    if (this.platform === 'unknown') return '';
    
    const descriptions = this.stepDescriptions[this.platform];
    const index = Math.min(this.step - 1, descriptions.length - 1);
    return descriptions[index] || '';
  }
}